/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetNftPurchasesResponse,
    GetNftPurchasesResponseFromJSON,
    GetNftPurchasesResponseToJSON,
    GetUnclaimedSupplyResponse,
    GetUnclaimedSupplyResponseFromJSON,
    GetUnclaimedSupplyResponseToJSON,
    InlineResponse20023,
    InlineResponse20023FromJSON,
    InlineResponse20023ToJSON,
    LoginResponse,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    NftPurchaseRequestBody,
    NftPurchaseRequestBodyFromJSON,
    NftPurchaseRequestBodyToJSON,
    NftPurchaseStatus,
    NftPurchaseStatusFromJSON,
    NftPurchaseStatusToJSON,
    NftPurchaseUpsert,
    NftPurchaseUpsertFromJSON,
    NftPurchaseUpsertToJSON,
    ThirdwebLoginBody,
    ThirdwebLoginBodyFromJSON,
    ThirdwebLoginBodyToJSON,
    ThirdwebRegisterBody,
    ThirdwebRegisterBodyFromJSON,
    ThirdwebRegisterBodyToJSON,
} from '../models';

export interface GetNftPurchaseRequest {
    id: string;
}

export interface GetNftPurchasesRequest {
    search?: string;
    status?: Array<NftPurchaseStatus>;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetThirdwebLoginPayloadRequest {
    address?: string;
    chainId?: string;
}

export interface PostThirdwebLoginPayloadRequest {
    thirdwebLoginBody?: ThirdwebLoginBody;
}

export interface SubmitNftPurchaseRequest {
    id: string;
}

export interface ThirdwebRegisterRequest {
    thirdwebRegisterBody?: ThirdwebRegisterBody;
}

export interface UpsertNftPurchaseRequest {
    nftPurchaseRequestBody?: NftPurchaseRequestBody;
}

export interface VerifyNftPurchaseRequest {
    id: string;
}

/**
 * ThirdwebApi - interface
 * @export
 * @interface ThirdwebApiInterface
 */
export interface ThirdwebApiInterface {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    getNftPurchaseRaw(requestParameters: GetNftPurchaseRequest): Promise<runtime.ApiResponse<NftPurchaseUpsert>>;

    /**
     */
    getNftPurchase(requestParameters: GetNftPurchaseRequest): Promise<NftPurchaseUpsert>;

    /**
     * 
     * @param {string} [search] 
     * @param {Array<NftPurchaseStatus>} [status] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    getNftPurchasesRaw(requestParameters: GetNftPurchasesRequest): Promise<runtime.ApiResponse<GetNftPurchasesResponse>>;

    /**
     */
    getNftPurchases(requestParameters: GetNftPurchasesRequest): Promise<GetNftPurchasesResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    getNftUnclaimedSupplyRaw(): Promise<runtime.ApiResponse<GetUnclaimedSupplyResponse>>;

    /**
     */
    getNftUnclaimedSupply(): Promise<GetUnclaimedSupplyResponse>;

    /**
     * 
     * @param {string} [address] 
     * @param {string} [chainId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    getThirdwebLoginPayloadRaw(requestParameters: GetThirdwebLoginPayloadRequest): Promise<runtime.ApiResponse<object>>;

    /**
     */
    getThirdwebLoginPayload(requestParameters: GetThirdwebLoginPayloadRequest): Promise<object>;

    /**
     * Used to log in standard users.
     * @param {ThirdwebLoginBody} [thirdwebLoginBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    postThirdwebLoginPayloadRaw(requestParameters: PostThirdwebLoginPayloadRequest): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     * Used to log in standard users.
     */
    postThirdwebLoginPayload(requestParameters: PostThirdwebLoginPayloadRequest): Promise<LoginResponse>;

    /**
     * Used to mint a NFT
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    submitNftPurchaseRaw(requestParameters: SubmitNftPurchaseRequest): Promise<runtime.ApiResponse<InlineResponse20023>>;

    /**
     * Used to mint a NFT
     */
    submitNftPurchase(requestParameters: SubmitNftPurchaseRequest): Promise<InlineResponse20023>;

    /**
     * Used to register a standard user.
     * @param {ThirdwebRegisterBody} [thirdwebRegisterBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    thirdwebRegisterRaw(requestParameters: ThirdwebRegisterRequest): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     * Used to register a standard user.
     */
    thirdwebRegister(requestParameters: ThirdwebRegisterRequest): Promise<LoginResponse>;

    /**
     * Callback used to sync their updated email in Thirdweb with Devour.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    updateThirdwebProfileEmailRaw(): Promise<runtime.ApiResponse<void>>;

    /**
     * Callback used to sync their updated email in Thirdweb with Devour.
     */
    updateThirdwebProfileEmail(): Promise<void>;

    /**
     * Used to get information about the next claimable NFT.
     * @param {NftPurchaseRequestBody} [nftPurchaseRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    upsertNftPurchaseRaw(requestParameters: UpsertNftPurchaseRequest): Promise<runtime.ApiResponse<NftPurchaseUpsert>>;

    /**
     * Used to get information about the next claimable NFT.
     */
    upsertNftPurchase(requestParameters: UpsertNftPurchaseRequest): Promise<NftPurchaseUpsert>;

    /**
     * Verify that the payment has been successfully processed and mints the NFT to the customer\'s wallet.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdwebApiInterface
     */
    verifyNftPurchaseRaw(requestParameters: VerifyNftPurchaseRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Verify that the payment has been successfully processed and mints the NFT to the customer\'s wallet.
     */
    verifyNftPurchase(requestParameters: VerifyNftPurchaseRequest): Promise<void>;

}

/**
 * no description
 */
export class ThirdwebApi extends runtime.BaseAPI implements ThirdwebApiInterface {

    /**
     */
    async getNftPurchaseRaw(requestParameters: GetNftPurchaseRequest): Promise<runtime.ApiResponse<NftPurchaseUpsert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getNftPurchase.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/nft-purchases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NftPurchaseUpsertFromJSON(jsonValue));
    }

    /**
     */
    async getNftPurchase(requestParameters: GetNftPurchaseRequest): Promise<NftPurchaseUpsert> {
        const response = await this.getNftPurchaseRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getNftPurchasesRaw(requestParameters: GetNftPurchasesRequest): Promise<runtime.ApiResponse<GetNftPurchasesResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/nft-purchases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftPurchasesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftPurchases(requestParameters: GetNftPurchasesRequest): Promise<GetNftPurchasesResponse> {
        const response = await this.getNftPurchasesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getNftUnclaimedSupplyRaw(): Promise<runtime.ApiResponse<GetUnclaimedSupplyResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/thirdweb/nft-unclaimed_supply`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnclaimedSupplyResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftUnclaimedSupply(): Promise<GetUnclaimedSupplyResponse> {
        const response = await this.getNftUnclaimedSupplyRaw();
        return await response.value();
    }

    /**
     */
    async getThirdwebLoginPayloadRaw(requestParameters: GetThirdwebLoginPayloadRequest): Promise<runtime.ApiResponse<object>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.address !== undefined) {
            queryParameters['address'] = requestParameters.address;
        }

        if (requestParameters.chainId !== undefined) {
            queryParameters['chainId'] = requestParameters.chainId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/thirdweb/login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getThirdwebLoginPayload(requestParameters: GetThirdwebLoginPayloadRequest): Promise<object> {
        const response = await this.getThirdwebLoginPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to log in standard users.
     */
    async postThirdwebLoginPayloadRaw(requestParameters: PostThirdwebLoginPayloadRequest): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThirdwebLoginBodyToJSON(requestParameters.thirdwebLoginBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Used to log in standard users.
     */
    async postThirdwebLoginPayload(requestParameters: PostThirdwebLoginPayloadRequest): Promise<LoginResponse> {
        const response = await this.postThirdwebLoginPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to mint a NFT
     */
    async submitNftPurchaseRaw(requestParameters: SubmitNftPurchaseRequest): Promise<runtime.ApiResponse<InlineResponse20023>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling submitNftPurchase.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/nft-purchases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20023FromJSON(jsonValue));
    }

    /**
     * Used to mint a NFT
     */
    async submitNftPurchase(requestParameters: SubmitNftPurchaseRequest): Promise<InlineResponse20023> {
        const response = await this.submitNftPurchaseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to register a standard user.
     */
    async thirdwebRegisterRaw(requestParameters: ThirdwebRegisterRequest): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/thirdweb/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThirdwebRegisterBodyToJSON(requestParameters.thirdwebRegisterBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Used to register a standard user.
     */
    async thirdwebRegister(requestParameters: ThirdwebRegisterRequest): Promise<LoginResponse> {
        const response = await this.thirdwebRegisterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Callback used to sync their updated email in Thirdweb with Devour.
     */
    async updateThirdwebProfileEmailRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/update-profile-email`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Callback used to sync their updated email in Thirdweb with Devour.
     */
    async updateThirdwebProfileEmail(): Promise<void> {
        await this.updateThirdwebProfileEmailRaw();
    }

    /**
     * Used to get information about the next claimable NFT.
     */
    async upsertNftPurchaseRaw(requestParameters: UpsertNftPurchaseRequest): Promise<runtime.ApiResponse<NftPurchaseUpsert>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdweb/upsert-nft-purchase`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NftPurchaseRequestBodyToJSON(requestParameters.nftPurchaseRequestBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NftPurchaseUpsertFromJSON(jsonValue));
    }

    /**
     * Used to get information about the next claimable NFT.
     */
    async upsertNftPurchase(requestParameters: UpsertNftPurchaseRequest): Promise<NftPurchaseUpsert> {
        const response = await this.upsertNftPurchaseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Verify that the payment has been successfully processed and mints the NFT to the customer\'s wallet.
     */
    async verifyNftPurchaseRaw(requestParameters: VerifyNftPurchaseRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling verifyNftPurchase.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/thirdweb/nft-purchases/{id}/verify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Verify that the payment has been successfully processed and mints the NFT to the customer\'s wallet.
     */
    async verifyNftPurchase(requestParameters: VerifyNftPurchaseRequest): Promise<void> {
        await this.verifyNftPurchaseRaw(requestParameters);
    }

}
